import { noop } from "lodash-es";

import { logPerformance } from "./env/Environment";

export const performanceLog = logPerformance
  ? (message: string, start: number) => {
      // eslint-disable-next-line no-console
      console.log(message, performance.now() - start + " ms");
    }
  : noop;
